export default [
  {
    name: "Preis",
    value: "price",
    direction: "asc",
    tooltip:
      "Alle folgenden Preise sind 1000-kg-Brutto-Endpreise inkl. 7 % MwSt. Es kommen keine Aufschläge hinzu.",
    infoPosition: "after",
  },
  {
    name: "Palette",
    value: "palette",
    direction: "",
    tooltip: "",
    infoPosition: "none",
  },
  {
    name: "Lieferzeit",
    value: "delivery-date",
    direction: "asc",
    tooltip:
      "Die Berechnung der Lieferzeiten basiert grundsätzlich auf den Tagen von Montag bis Freitag. Bitte beachten Sie, dass die Lieferfrist durch bundesweite und regionale Feiertage abweichen kann.",
    infoPosition: "before",
  },
  {
    name: "Zahlart",
    value: "payment-type",
    direction: "",
    tooltip: "",
    infoPosition: "none",
  },
  {
    name: "Bewertung",
    value: "rating",
    direction: "desc",
    tooltip: "",
    infoPosition: "none",
  },
];
